'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("colorUtils", function () {
  var padLeft = function padLeft(str, length) {
    var toPad = length - str.length;
    return new Array(toPad + 1).join("0") + str;
  };
  var limitToBoundaries = function limitToBoundaries(number, min, max) {
    return number < 0 ? min : number > max ? max : number;
  };
  var colorUtils = {
    // Convert a hex color to an RGB array e.g. [r,g,b]
    // Accepts the following formats: FFF, FFFFFF, #FFF, #FFFFFF
    hexToRgb: function hexToRgb(hex) {
      var r, g, b, parts;
      // Remove the hash if given
      hex = hex.replace('#', '');
      // If invalid code given return white
      if (hex.length !== 3 && hex.length !== 6) {
        return [255, 255, 255];
      }
      // Double up charaters if only three suplied
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      // Convert to [r,g,b] array
      r = parseInt(hex.substr(0, 2), 16);
      g = parseInt(hex.substr(2, 2), 16);
      b = parseInt(hex.substr(4, 2), 16);
      return [r, g, b];
    },
    // Converts an RGB color array e.g. [255,255,255] into a hexidecimal color value e.g. 'FFFFFF'
    rgbToHex: function rgbToHex(color, alpha) {
      var r = padLeft(limitToBoundaries(color[0], 0, 255).toString(16), 2);
      var g = padLeft(limitToBoundaries(color[1], 0, 255).toString(16), 2);
      var b = padLeft(limitToBoundaries(color[2], 0, 255).toString(16), 2);
      return "#" + r + g + b;
    },
    // Generates an array of color values in sequence from colors[0] to colors[X] using the specified number of steps
    generateGradient: function generateGradient(colors, nbSteps) {
      var stops = _.map(colors, function (color, i) {
        return {
          color: color,
          stop: parseInt(i * 100 / (colors.length - 1))
        };
      });
      var result = [];
      var getColorBetween = function getColorBetween(color1, color2, ratio) {
        var rgbA = colorUtils.hexToRgb(color1);
        var rgbB = colorUtils.hexToRgb(color2);
        var calcHex = function calcHex(colorA, colorB, ratio) {
          var cPerUnit = (colorB - colorA) / 100;
          return Math.round(cPerUnit * ratio + colorA);
        };
        var rVal = calcHex(rgbA[0], rgbB[0], ratio),
          gVal = calcHex(rgbA[1], rgbB[1], ratio),
          bVal = calcHex(rgbA[2], rgbB[2], ratio);
        return colorUtils.rgbToHex([rVal, gVal, bVal]);
      };
      var getColorAt = function getColorAt(colorPosition) {
        for (var i = 0; i < stops.length - 1; i++) {
          var currentStop = stops[i];
          var nextStop = stops[i + 1];
          if (colorPosition === currentStop.stop) {
            return currentStop.color;
          } else if (colorPosition <= nextStop.stop) {
            var total = nextStop.stop - currentStop.stop;
            var offset = colorPosition - currentStop.stop;
            var ratio = offset / total * 100;
            return getColorBetween(currentStop.color, nextStop.color, ratio);
          }
        }
        return stops[stops.length - 1].color;
      };
      _.times(nbSteps, function (i) {
        var colorPosition = parseInt(i * 100 / (nbSteps - 1));
        result.push(getColorAt(colorPosition));
      });
      return result;
    }
  };
  return colorUtils;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/colorUtils.js
// module id = 2746
// module chunks = 13